<template>
  <div class="navigation investor">
    <v-list class="investor-nav-list">
      <v-list-item :to="`/investors/${$route.params.investorId}/info`" active-class="active">
        <v-list-item-content class="text-center">
          <div class="navigation-name">{{ $t('navigation.info') }}</div>
        </v-list-item-content>
      </v-list-item>
      <v-list-item :to="`/investors/${$route.params.investorId}/autos`" active-class="active">
        <v-list-item-content class="text-center">
          <div class="navigation-name">{{ $t('navigation.autos') }}</div>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </div>
</template>

<script>
export default {
  name: 'InvestorNavigation',
};
</script>

<style lang="scss" scoped>
.navigation {
  &.investor {
    width: 100%;
    background: transparent;

    .investor-nav-list {
      display: flex;
      background: transparent;

      @media (max-width: (650px)) {
        display: block;
      }
    }
  }
}
</style>
